<template>
  <main class="home">
    <logoData/>
    <section class="areaHomeKeyvisual" id="HomeKeyvisual">
      <div class="areaVideo">
				<div class="areaHomeKeyvisualAnime"></div>
      </div>
<!--
			<svg class="areaSvgLogo">
				<use class="svgLogoToyoshima" xlink:href="#Logo"></use>
			</svg>
-->

      <div class="areaHomeKeyvisualLogo">
        <h1><img src="/asset/images/pages/home/toyoshima_shinbun.svg" alt="豊嶋精密工業株式会社"><span>Toyoshima Precision Industry</span></h1>
      </div>

			<div class="areaHomeKeyVisualInfo">
				<div class="areaHomeKeyVisualISO">
					<p><span>認証取得</span></p>
					<p>ISO9001:2015</p>
				</div>
				<div class="areaHomeKeyVisualMachine">
					<p><span>新規導入</span></p>
					<dl>
						<dt>BREVIS-1212AJ</dt><dd>オールラウンドファイバーレーザマシン</dd>
					</dl>
					<dl>
						<dt>FLW-1500MT</dt><dd>ハンディファイバーレーザ溶接機</dd>
					</dl>
					<dl>
						<dt>EGB4010E</dt><dd>デュアルサーボベンディングマシン</dd>
					</dl>
				</div>
			</div>

<!--
			<div class="areaHomeKeyvisualCatch">
<p><span class="defo1">つ</span><span class="defo2">く</span><span class="defo3">り</span></p><p><span class="defo4">つ</span><span class="defo5">づ</span><span class="defo6">け</span><span class="defo7">て</span></p><p><span class="defo8">半</span><span class="defo9">世</span><span class="defo10">紀</span></p>
			</div>
-->
      <div class="areaHomeKeyvisualText">
        <p>
豊嶋精密工業株式会社は<br>精密板金加工を専門とする<span class="brSp"></span>会社です
        </p>
      </div>
    </section>

    <section id="HomeServices" class="tagJumpTarget">
      <div class="areaHomeH2">
        <h2>Business</h2>
      </div>
      <ul class="areaHomeServices designHomeBlock">
        <li class="tagJumpTarget" id="HomeServicesMain">
          <div class="_content">
            <h3><span>精密板金加工</span></h3>
            <div class="_grid">
              <p>
材料調達から板金加工、スポット溶接、TIG溶接、組立、塗装、メッキ、シルク印刷、彫刻などの2次加工もOK
              </p>
            </div>
					</div>

					<div class="_items">
<router-link to="/business" class="fromLeft" v-scroll:[activeFlg]='handleScrollSelf'>業務内容</router-link>
<router-link to="/products?list=1" class="fromLeft" v-scroll:[activeFlg]='handleScrollSelf'>製作事例</router-link>
<router-link to="/business/equipment?list=1" class="fromLeft" v-scroll:[activeFlg]='handleScrollSelf'>設備</router-link>
<router-link to="/business/material?list=1" class="fromLeft" v-scroll:[activeFlg]='handleScrollSelf'>取扱素材</router-link>
<router-link to="/deal" class="fromLeft" v-scroll:[activeFlg]='handleScrollSelf'>お見積り</router-link>
					</div>

          <div class="_content _plus">
						<img class="_icon" src="/asset/images/pages/update/plus.svg" alt="プラス情報アイコン">
            <div class="_block">
							<h4>さらなる対応力</h4>
              <p>
ファイバーレーザマシン導入で、より困難な素材、柔軟な加工を実現
              </p>
            </div>
						<img src="/asset/images/pages/update/process_brevis.png" alt="ファイバーレーザ加工様子">
          </div>

				</li>
      </ul>
    </section>

    <section id="HomeCompany" class="tagJumpTarget">
      <div class="areaHomeH2">
        <h2>About us</h2>
      </div>
      <ul class="areaHomeCompany designHomeBlock">
        <li class="" id="HomeCompanyMain">
          <div class="_content">
            <div class="_grid">
              <p>
1959年事業開始以来、その対応力と職人の技術により着実に会社規模を大きくし、より対応可能な案件を増やしています。
              </p>
            </div>
          </div>

          <div class="_items">
<router-link to="/policy" class="fromLeft" v-scroll:[activeFlg]='handleScrollSelf'>会社方針</router-link>
<router-link  :to="{path:'/policy', hash:'AboutQuality'}"  class="fromLeft" v-scroll:[activeFlg]='handleScrollSelf'>品質方針</router-link>
<router-link to="/about" class="fromLeft" v-scroll:[activeFlg]='handleScrollSelf'>会社情報</router-link>
<router-link to="/recruit" class="fromLeft" v-scroll:[activeFlg]='handleScrollSelf'>採用情報</router-link>
<router-link :to="{path:'/about', hash:'AboutMap'}" class="fromLeft" v-scroll:[activeFlg]='handleScrollSelf'>アクセス</router-link>
          </div>
          <div class="_content _plus">
						<img class="_icon" src="/asset/images/pages/update/plus.svg" alt="プラス情報アイコン">
<router-link :to="{path:'/about', hash:'AboutISO'}" class="pageLink">
            <div class="_block tagJumpTarget" id="HomeCompanyISO">
							<h3>国際標準規格品質</h3>
							<img src="/asset/images/pages/iso/ias.png" alt="ISO9001:2015 G-CERTI承認ロゴ">
              <p>
当社の品質マネージメントシステムは国際標準化機構：ISOに承認されました。ISO9001:2015
              </p>
            </div>
</router-link>
          </div>
        </li>
      </ul>
		</section>

    <section id="HomeInfomation" class="tagJumpTarget">
      <div class="areaHomeH2">
        <h2>News</h2>
      </div>
      <ul class="areaHomeInfomationPickup" title="pickup">
<li v-for="(j, index) in displayListPickup.slice(0,2)" :key="index">
  <article>
    <p class="_image">
      <img-plus :img-src="j.image" :img-thumb="j.thumb" :img-alt="j.alt" :full-screen="true" at-place="list" />
    </p>
    <div class="_block">
      <p class="_date">{{isoDateToDisplayDate(j.date)}}</p>
      <h1><router-link class="pageLink" :to="{path:'/about/announcement', hash:j.id}"><span>{{j.title}}</span></router-link></h1>
      <p class="_content" v-text="limitedTextDisplay(j.content)"></p>
    </div>
  </article>
</li>
      </ul>

      <ul class="areaHomeInfomationList" title="list">
<li v-for="(j, index) in displayList.slice(0,5)" :key="index">
  <article>
    <div class="_block">
			<router-link class="pageLink" :to="{path:'/about/announcement', hash:j.id}">
				<p class="_date">{{isoDateToDisplayDate(j.date)}}</p>
				<h1><span>{{j.title}}</span></h1>
			</router-link>
    </div>
  </article>
</li>
			<li class="informationLink">
				<div class="_block">
<router-link class="pageLink" to="/about/announcement?list=1">News一覧</router-link>
				</div>
			</li>
      </ul>
    </section>

  </main>
</template>

<script>
import logoSvg from '@/components/logo.vue'
import imgPlus from '@/components/ImgPlus.vue'

let activeFlg = true

export default {
  name: 'home',
/* vue-head 表記内容 */
/*
  head: {
    title() {
      return {
        inner: this.$route.name,
        separator: '|',
        complement: this.$store.getters.siteName,
      }
    },
    meta:function() {
			return [
				{ name: 'description', content: this.description, id:'Desc' },
				{ name: 'keywords', content: this.keywords, id:'Keyw'},
				{ property: 'og:url', content: this.isUrl, id:'OgUrl' },
				{ property: 'og:type', content: this.ogType, id:'OgType' },
				{ property: 'og:title', content: this.isTitle, id:'OgTitle' },
				{ property: 'og:description', content: this.description, id:'OgDesc' },
				{ property: 'og:site_name', content: this.ogSiteName, id:'OgSite' },
				{ property: 'og:image', content: this.ogImage, id:'Ogimag' },
			]
    },
  },
*/
  components:{ 
'logoData': logoSvg, 
'imgPlus':imgPlus,
  },
  data() {
    return {
      result:[],
      originList:[],
      displayListPickup:[],
      displayList:[],
      activeFlg:true,
			pageTitle:"オフィシャルサイト",
			description:"豊嶋精密工業株式会社は1959年創業以来金属加工を行い、現在精密板金を専門としながら金属加工全般を請け負う会社です。経験と技術から難しい板金のご依頼も対応しています。",
			keywords:"豊嶋精密工業株式会社 精密板金加工",
			ogType:"website",
    }
  },
  computed: {
  },
  created:function() {this._log("created "+this.$options.name)
  },
  beforeMount:function() {this._log("beforeMount "+this.$options.name)
    this.$store.watch(
      (state, getters) => getters.originListInformation,
      (newValue, oldValue) => {
					this.originList = this.$store.getters.originListInformation
					this.selectPickupList()
      }
    )
	},
  mounted: function() {this._log("mounted "+this.$options.name)
    this.$store.commit('updatePageSectionInfo', this.gatherTagId())
    this.$store.commit('updatePageBackgroundStyle', '')

/*head情報をセットする*/
    this.$store.commit('updateCurrentTitle', this.pageTitle)
    this.$store.commit('updateCurrentDescription', this.description)
    this.$store.commit('updateCurrentKeywords', this.keywords)
    this.$store.commit('updateCurrentOgUrl', this.isUrl)
    this.$store.commit('updateCurrentOgType', 'website')
    this.$store.commit('updateCurrentOgDesc', this.description)
    this.$store.commit('updateLinkCanonical', '')
		this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())

//表示用のリスト作成
		if(this.originList.length == 0) {
			this.originList = this.$store.getters.originListInformation
			this.selectPickupList()
		}
  },
  beforeUpdate:function() {this._log("beforeUpdate "+this.$options.name)
	},
  updated: function() {this._log("updated "+this.$options.name)
//    this.$store.commit('updatePageSectionInfo', this.gatherTagId())
//    this.$store.commit('updatePageBackgroundStyle', '')
	},
  methods: {
    convertCsvStringToArray(str) {
      return str.split("\n").map(s => s.split(","))
    },
/*information pickup選別*/
/*information pickup以外選別*/
    selectPickupList() {
      this.displayListPickup = this.originList.filter((aList) => aList.flg == true)
      this.displayList = this.originList.filter((aList) => aList.flg == false)

			this.displayListPickup.sort((first,second) => {return this.newOrder(first.date, second.date)})
			this.displayList.sort((first,second) => {return this.newOrder(first.date, second.date)})
    },
    uniqueId(aNumber) {
      return "Announce" + aNumber
    },
    setInnerLink(aNumber) {
      return {name:"/about/announcement", hash:"#Announce" + aNumber}
    },
    newOrder(firstDate, secondDate) {
      let aFirstDate = new Date(firstDate)
      let aSecondDate = new Date(secondDate)

      let aFirst = aFirstDate.getTime()
      let aSecond = aSecondDate.getTime()
      if(aFirst > aSecond) {
        return -1
      } else if(aFirst < aSecond) {
        return 1
      } else {
        return 0
      }
    },
		limitedTextDisplay(text) {
			let aContinue = "..."
			if(text.length < 80 ) {
				aContinue = ""
			}
			return text.slice(0, 80) + aContinue
		},
  },
/*ページ移動の際、イベントリスナー 登録要素を削除する*/
  beforeRouteLeave(to, from, next) {
//this._log("[LEAVE] To: " + to.path, + " From: " + from.path);
    this.activeFlg = false
    next();
  },
}
</script>

<style>
</style>
